module.exports = __webpack_public_path__ + "img/cgd.fed8a702.svg";